// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9a006a3d","703":"907d8a96"}[chunkId] + ".chunk.js";
};